var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "item-menu" } }, [
    _c("div", { staticClass: "header" }, [
      _vm._v(
        "\n        " +
          _vm._s(_vm.$t("form.formElements.formElements")) +
          "\n        "
      ),
      _c(
        "span",
        {
          staticClass: "md-icon",
          on: {
            click: function ($event) {
              return _vm.$emit("close")
            },
          },
        },
        [_vm._v("close")]
      ),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "content" },
      [
        _vm._l(_vm.items, function (item) {
          return _c(
            "div",
            {
              key: item.text,
              staticClass: "item",
              class: { disabled: _vm.isDisabled(item.id) },
              attrs: { draggable: !_vm.isDisabled(item.id) },
              on: {
                dragstart: function ($event) {
                  return _vm.onDragStart(item)
                },
              },
            },
            [
              _c("div", { staticClass: "item-image" }, [
                _c("span", { staticClass: "md-icon" }, [
                  _vm._v(_vm._s(item.icon)),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "item-text" }, [
                _vm._v(_vm._s(item.text)),
              ]),
            ]
          )
        }),
        _vm._v(" "),
        _c("div", { staticClass: "title" }, [
          _vm._v(_vm._s(_vm.$t("form.basicElements.basicElements"))),
        ]),
        _vm._v(" "),
        _vm._l(_vm.keyAreas, function (item) {
          return _c(
            "div",
            {
              key: item.text,
              staticClass: "item",
              class: { disabled: _vm.isDisabled(item.id) },
              attrs: { draggable: !_vm.isDisabled(item.id) },
              on: {
                dragstart: function ($event) {
                  return _vm.onDragStart(item)
                },
              },
            },
            [
              _c("div", { staticClass: "item-image" }, [
                _c("span", { staticClass: "md-icon" }, [
                  _vm._v(_vm._s(item.icon)),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "item-text" }, [
                _vm._v(_vm._s(item.text)),
              ]),
            ]
          )
        }),
        _vm._v(" "),
        _c("div", { staticClass: "title" }, [
          _vm._v(_vm._s(_vm.$t("form.surveyElements.surveyElements"))),
        ]),
        _vm._v(" "),
        _vm._l(_vm.surveyElements, function (item) {
          return _c(
            "div",
            {
              key: item.text,
              staticClass: "item",
              class: { disabled: _vm.isDisabled(item.id) },
              attrs: { draggable: !_vm.isDisabled(item.id) },
              on: {
                dragstart: function ($event) {
                  return _vm.onDragStart(item)
                },
              },
            },
            [
              _c("div", { staticClass: "item-image" }, [
                _c("span", { staticClass: "md-icon" }, [
                  _vm._v(_vm._s(item.icon)),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "item-text" }, [
                _vm._v(_vm._s(item.text)),
              ]),
            ]
          )
        }),
        _vm._v(" "),
        _c("div", { staticClass: "title" }, [
          _vm._v(_vm._s(_vm.$t("form.pageElements.pageElements"))),
        ]),
        _vm._v(" "),
        _vm._l(_vm.pageElements, function (item) {
          return _c(
            "div",
            {
              key: item.text,
              staticClass: "item",
              class: { disabled: _vm.isDisabled(item.id) },
              attrs: { draggable: !_vm.isDisabled(item.id) },
              on: {
                dragstart: function ($event) {
                  return _vm.onDragStart(item)
                },
              },
            },
            [
              _c("div", { staticClass: "item-image" }, [
                _c("span", { staticClass: "md-icon" }, [
                  _vm._v(_vm._s(item.icon)),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "item-text" }, [
                _vm._v(_vm._s(item.text)),
              ]),
            ]
          )
        }),
        _vm._v(" "),
        _c("div", { staticStyle: { "margin-top": "100px" } }),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }